<template>
  <div class="reports">
    <b-card no-body>
      <b-tabs
        class="mr-0 full-height"
        pills
        small
        ref="my-tabs"
        vertical
        content-class="mt-0 col-10"
        lazy
        v-model="tabIndex"
        nav-wrapper-class="p-1 col-2 shadow"
        :nav-class="navClass"
        :title="loading && 'Loading table data please wait ....'"
        @input="resetTableData"
      >
        <b-tab
          lazy
          v-for="(item, i) in datasetdata"
          :key="'dyn-tab-' + i"
          :title="convertUnderScoreToSpace(item.DATASET_NAME)"
          no-body
          title-item-class="text-nowrap transform-uppercase"
        >
          <div v-if="item.DATASET_ID === selected_dataset">
            <v-server-table
              :options="options"
              :columns="columns"
              :ref="item.DATASET_ID"
              :key="selected_dataset"
            >
              <template v-slot:beforeTable>
                <div class="">
                  <vt-pagination
                    class="
                      mt-1
                      mb-1
                      ml-0
                      pr-5
                      justify-content-md-end
                      border-0 border-0
                    "
                  >
                  </vt-pagination>
                  <div
                    v-if="columns.length && tableData.length"
                    class="buttons--group"
                  >
                    <b-form-group class="m-0" label-cols-lg="0">
                      <b-button
                        size="sm"
                        variant="outline-primary"
                        class="ml-1 mr-1"
                        @click="downloadCSV"
                        style="font-size: 10px"
                      >
                        <b-icon-download
                          font-scale="1"
                        />
                      </b-button>
                    </b-form-group>
                  </div>
                </div>
              </template>
              <template v-slot:afterBody>
                <div v-if="loading" style="text-align: center">
                  <div class="overlay-loader"></div>
                  <b-spinner
                    variant="primary"
                    label="Spinning"
                    class="clip-loader"
                  >
                  </b-spinner>
                  <!-- <span class="text-primary"
                    >Loading table data please wait...</span
                  > -->
                </div>
              </template>
            </v-server-table>
          </div>
        </b-tab>
        <!-- Render this if no tabs -->
        <template #empty>
          <div v-if="loading" class="adjust-text">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
            <span class="text-primary" style="position: absolute; padding: 5px"
              >Loading datasets please wait...</span
            >
          </div>
          <div v-else class="adjust-text">
            <span class="text-muted">There are no datasets available</span>
          </div>
        </template>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import Vue from "vue";
import { createRequester } from "@/utility/api.js";
import { ServerTable } from "vue-tables-2-premium";
import VtPagination from "vue-tables-2-premium/compiled/components/VtPagination";
import {
  TabsPlugin,
  BCard,
  BSpinner,
  BFormGroup,
  BButton,
  BIconDownload,
} from "bootstrap-vue";
import { NREST } from "config";
import VtSortControl from "./sortControll.vue";
Vue.use(TabsPlugin);
Vue.use(ServerTable, {}, false, require("./theme"), {
  sortControl: VtSortControl,
});
const request = createRequester();
const perPage = 20;

export default {
  name: "report-management",
  props: {
    report_id: {
      type: [String, Number],
      required: true,
    },
    JString: {
      type: Object,
      required: true,
    },
  },

  components: {
    BCard,
    VtPagination,
    BSpinner,
    BFormGroup,
    BButton,
    BIconDownload
  },

  watch: {
    report_id: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.getDataDataSetData(newVal);
        }
      },
      immediate: true,
    },
  },

  data() {
    return {
      datasetdata: [],
      reportdata: {},

      tableData: [],

      tabIndex: 0,
      loading: null,
    };
  },

  computed: {
    navClass() {
      const classes = ["pl-2 scroll-y scrollable-tabs-nav"];
      this.loading === true && classes.push("disable-tabs");
      return classes;
    },
    selected_dataset() {
      return ((this.datasetdata || [])[this.tabIndex] || {}).DATASET_ID;
    },
    selected_datasetName() {
      return ((this.datasetdata || [])[this.tabIndex] || {}).DATASET_NAME;
    },

    columns: {
      get() {
        return Object.keys(this.tableData[0] || {});
      },
    },

    options() {
      const vm = this;
      return {
        debounce: 1000,
        filterable: false,
        pagination: {
          show: false,
          edge: false,
          chunk: 3
        },
        stickyHeaderBackground: true,
        resizableColumns: true,
        perPage,
        perPageValues: [3],
        texts: {
          loading: "...",
          loadingError: "Oops! Something went wrong",
        },
        requestFunction(data) {
          return vm.getReportData(data);
        },
        responseAdapter: (data) => {
          let count = data && data[0] != null ? data[0]["rc_internal"] : 0;
          return {
            data,
            count: count,
          };
        },
        templates: {},
      };
    },
  },

  methods: {
    resetTableData() {
      this.tableData = [];
      this.tableData.length = 0;
    },
    convertUnderScoreToSpace(str) {
      return str
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/^(.)/, function ($1) {
          return $1.toUpperCase();
        });
    },
    getDataDataSetData(report_id) {
      this.loading = true;
      const url = `${NREST}reportmanager/report/read/${report_id}`;
      const options = {
        url,
        body: JSON.stringify({
          dataobj: {
            repId: report_id,
            sort: "DATASET_NAME",
            dir: "ASC"
          },
        }),
      };
      request(options)
        .then(
          ((result) => {
            if (
              result.message !== undefined ||
              result.response === "unsuccess"
            ) {
              this.loading = false;
              return;
            }
            this.loading = false;
            this.reportdata = result.reportdata || {};
            this.datasetdata = result.datasetdata || [];
            return result;
          }).bind(this)
        )
        .catch(() => (this.loading = false));
    },

    getReportData(params) {
      this.loading = true;
      console.log("report table options ", params, this.selected_dataset);
      if (!this.selected_dataset) return;
      const url = `${NREST}reportmanager/dataset/read/${this.selected_dataset}`;
      const body = JSON.stringify({
        dataobj: {
          JString: this.JString,
          start: (parseInt(params.page) - 1) * (parseInt(params.limit) + 1 - 1),
          limit: params.limit,
          sort: params.orderBy || "",
          dir: { 0: "ASC", 1: "DESC" }[params.ascending || 0],
        },
      });

      const options = { url, body };
      return request(options)
        .then(
          ((result) => {
            if (
              result.message !== undefined ||
              result.response === "unsuccess"
            ) {
              throw new Error("Invalid server response");
            }
            this.tableData = Array.isArray(result) ? result : [];
            this.loading = false;
            return Promise.resolve(result);
          }).bind(this)
        )
        .catch((e) => {
          Promise.reject(e);
          this.loading = false;
        });
    },

    downloadCSV() {
      const url = `${NREST}reportmanager/dataset/read/${this.selected_dataset}`;
      const body = JSON.stringify({
        dataobj: { 
          JString: this.JString, 
          start: 0,
          limit: "",
          sort: "",
          dir:"ASC"
        },
        redirect: "follow",
      });
      const options = {
        url,
        body,
        headers: { Accept: "text/csv" },
        blob: true,
      };
      this.showNotificationSpinner("Downloading. Please Wait ...");
      return request(options)
        .then(
          ((result) => {
            if (result.status === "unsuccess")
              throw new Error((result || {}).error || result);
            var blob = new Blob([result]);
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            a.href = url;
            a.download = this.selected_datasetName + ".csv";
            this.closeNotificationSpinner();
            a.click();
          }).bind(this)
        )
        .catch((e) => {
          console.error(e);
        });
    },

    closeNotificationSpinner() {
      const tpl = document.getElementById('notificationWrap');
      (tpl && tpl.parentNode) && tpl.parentNode.removeChild(tpl);
    },
    showNotificationSpinner(msg) {
      const STYLE = "position: fixed; bottom: 0; right: 0; background: #1d1d77; padding: 10px; color: #fff; box-shadow: rgba(0, 0, 0, 0.78) -2px 1px 4px 0px; border-radius: 5px 0 0 0; font-weight: bold;z-index: 99999999;";
      const tpl = document.getElementById('notificationWrap');
      if (!(tpl && tpl.length)) {
        const DIV = document.createElement('div');
        DIV.setAttribute('id', "notificationWrap");
        DIV.setAttribute("style", STYLE);
        DIV.innerHTML = '<span role="status" class="spinner-border text-primary"><span class="sr-only">Spinning</span></span>&nbsp;&nbsp;&nbsp;' + msg;
        document.querySelector('body').appendChild(DIV);
      }
      else {
        this.closeNotificationSpinner();
        this.showNotificationSpinner(msg)
      }
    },
  },
};
</script>

<style scoped lang="scss">
.reports {
  overflow: hidden;
  .full-height {
    height: 100vh;
  }
  .adjust-text {
    position: relative;
    top: 0;
    right: -26%;
  }
  .buttons--group {
    position: absolute;
    right: 0;
    top: 0;
  }

  ::v-deep {
    .shadow {
      border-right: 1px solid #eee;
      box-shadow: 0 7px 10px rgb(0 0 0 / 30%);
    }
    .transform-uppercase {
      text-transform: uppercase;
    }
    .nav-pills .nav-link.active, .nav-pills .show > .nav-link {
      background-color: #070f63;
    }
    .scrollable-tabs-nav {
      position: relative;
      width: 100%;
      white-space: nowrap;
      transition: all 0.2s;
      // transform: scale(0.98);
      will-change: transform;
      user-select: none;
      max-height: 100vh;
      cursor: pointer;

      flex-wrap: nowrap;

      a {
        color: #3e3c3e;
        border-bottom: 1px solid #eee;
      }
      a.active {
        color: white;
      }
    }

    .scroll-y {
      & {
        white-space: nowrap;
        overflow: hidden;
        overflow-y: auto;
      }
    }

    .disable-tabs {
      pointer-events: none;
      cursor: not-allowed;
    }

    .VueTables {
      .VuePagination {
        nav {
          display: flex;
          flex-direction: row-reverse;
        }
        font-size: 10.9px;
        font-family: Nunito Sans,Roboto,sans-serif;
        .page-link {
          font-size: 11px;
        }
      }
      .VuePagination__count {
        margin: 0;
        padding: 4px;
        flex: 1 0 0;
        margin-right: 5px;
      }
      .VuePagination__pagination {
        margin-bottom: 0.3rem;
      }
      .overlay-loader {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: white;
        opacity: 0.8;
        filter: blur(5px);
      }
      .clip-loader {
        position: absolute;
        left: 50%;
        right: -50%;
        top: 45%;
      }

      .table {
        max-height: 75vh;
        font-size: 12px;
        font-family: Nunito Sans,Roboto,sans-serif;

        th,
        td {
          padding: 5px 15px;
        }

        th,
        td {
          white-space: nowrap;
          vertical-align: middle;
          max-width: 150px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .table > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
      .table.b-table > tfoot > tr > [aria-sort]:not(.b-table-sort-icon-left) {
        outline: none;
      }

      .b-table-sticky-header {
        overflow-y: auto;
        min-height: 200px;
        // max-height: 70vh;
        max-height: calc(100vh - var(32px) - 150px);

        &::-webkit-scrollbar {
          width: 7px;
          height: 7px;
        }

        &::-webkit-scrollbar-track {
          border-radius: 50px;
          background: #ccc;
        }

        &::-webkit-scrollbar-thumb {
          border-radius: 50px;
          background: var(--primary);
        }

        &::-webkit-scrollbar-thumb:window-inactive {
          border-radius: 20px;
          background: #eee;
        }
      }

      display: flex;
      flex-direction: column;
      height: 100%;
      position: relative;

      .table-responsive {
        flex: 1;
        overflow: auto;
        max-height: 92vh;

        table {
          width: 100%;
        }
      }

      // Headers
      th {
        position: sticky;
        top: 0;
        background: #070f63;
        color: #fff;
        padding: 5px 15px;
        text-transform: uppercase;
      }

      // Sorting
      .VueTables__sortable {
        cursor: pointer;
        white-space: nowrap;
      }
      .VueTables__sort-icon {
        color: hsl(210, 16%, 82%);
        margin-left: 1px;
      }

      // Filtering
      .VueTables__filters-row {
        th {
          top: 35px;
        }

        input {
          font-size: 10.9px;
          padding: 1px 1px;
          width: 90%;
          border: 1px solid hsl(214, 15%, 91%);
          border-radius: 4px;
        }
      }
    }
  }
}
</style>